import React from "react";
import * as yup from "yup";
import { ControlledInput } from "./ControlledForm";
import { Control } from "react-hook-form";

interface IControlledEmail {
  name: string;
  control: Control;
  defaultValue: string;
  readonly: boolean;
  fieldName: string;
  required?: boolean;
  onBlur?: () => {};
  onChange?: () => {};
  label?: string;
  errors?: any;
  id?: string;
}

export const ControlledEmail = ({
  name,
  control,
  defaultValue,
  readonly,
  required,
  fieldName,
  onBlur,
  onChange,
  label,
  errors,
  id,
}: IControlledEmail) => {
  return (
    <ControlledInput
      id={id}
      name={name}
      control={control}
      defaultValue={defaultValue}
      readonly={readonly}
      label={label}
      required={required}
      errors={errors}
      onBlur={onBlur}
      onChange={onChange}
      autoComplete='email'
      rules={{
        ...(readonly
          ? {}
          : {
              validate: async (email: string) =>
                (await yup
                  .object()
                  .shape({ email: yup.string().email() })
                  .validate({ email })
                  .catch(() => `${fieldName} must be a valid email address`)) as boolean | string,
            }),
      }}
    />
  );
};
